import { isGlobalFeatureEnabled } from "owa-feature-flags";

export function isEventPollRequest(itemClass: string | undefined): boolean {
    if (!isGlobalFeatureEnabled("rp-event-poll-calendar-card")) {
        return false;
    }
    return !!(itemClass &&
        itemClass.match(/^ipm\.(note\.)?schedule\.meeting\.eventpoll\.(request|canceled)/i));
}
